// 문서용 요청 예시를 보여주는 컴포넌트 (읽기 전용)
import { useEffect, useState } from 'react';
import jsonFormat from 'json-format';
import JsonCode, { JSON_INDENT } from './JsonCode';
import classes from './DescriptionPageTemplate.module.css';

/**
 * 요청 예시.
 *
 * API TEST 영역의 Parameter 에디터와 달리 편집할 수 없다. 그쪽은 사용자가 값을 고쳐
 * Send 하는 작업 공간이라 문서에 적힌 정본이 화면에서 사라진다.
 * 이 컴포넌트는 파라미터 표와 같은 섹션에 있어 스키마와 예시를 바로 대조하는 자리다.
 *
 * @param {Object|Array<Object>} bodyExample - 문서 데이터의 body_example. 배열이면 예시가 여러 개다
 * @returns {JSX.Element|null} 값이 없으면 null
 */
const RequestExample = ({ bodyExample }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [copied, setCopied] = useState(false);

  // 버전을 바꾸면 없는 탭이 선택된 채로 남을 수 있다. 버전마다 예시 수가 다르다
  useEffect(() => {
    setActiveIndex(0);
  }, [bodyExample]);

  if (!bodyExample) return null;

  const examples = Array.isArray(bodyExample) ? bodyExample : [bodyExample];
  if (examples.length === 0) return null;

  // _tabName 은 탭 이름을 담는 메타 필드라 예시 본문에 노출하지 않는다.
  // API TEST 의 Parameter 에디터와 같은 처리다
  const active = examples[activeIndex] || examples[0];
  const { _tabName, ...body } = active;
  const bodyString = jsonFormat(body, JSON_INDENT);

  // 예시가 하나면 탭이 정보를 주지 않는다. 읽기 전용이라 전환할 대상도 없다
  const showTabs = examples.length > 1;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(bodyString);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      window.prompt('아래 내용을 복사하세요', bodyString);
    }
  }

  return (
    <div className={classes.codeBlock}>
      <div className={classes.codeBar}>
        {showTabs ? (
          <div className={classes.codeTabs}>
            {examples.map((item, i) => (
              <button
                type="button"
                key={i}
                className={
                  i === activeIndex
                    ? `${classes.codeTab} ${classes.codeTabActive}`
                    : classes.codeTab
                }
                onClick={() => setActiveIndex(i)}
              >
                {item._tabName || `Example ${i + 1}`}
              </button>
            ))}
          </div>
        ) : (
          <span className={classes.codeTitle}>Request body 예시</span>
        )}
        <button type="button" className={classes.codeCopy} onClick={handleCopy}>
          {copied ? '복사됨' : '복사'}
        </button>
      </div>
      <JsonCode value={bodyString} className={classes.codeBody} />
    </div>
  );
};

export default RequestExample;
